import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router";
import { CRYPTO_SECRET_KEY, RODEO_PAGE_NAME, URLS } from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import Sponsor from "src/components/common/Sponsor";
import JoinChallengeModal from "../modal/joinChallengeModal";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { useAppPerformanceListSelector } from "src/_common/hooks/selectors/eventSelector";
import moment from "moment";
import StatusModal from "../modal/statusModal";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

const CreateChallengeComponent: any = () => {
  const { eventId, performanceId } = useParams<any>();
  const [activeTab, setActiveTab] = useState<"create" | "join">("create");
  const eventApi = useEventApi();
  const [challengeList, setChallengeList] = useState<any>();
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const toast = useToaster();
  const [showJoinChallengeModal, setShowJoinChallengeModal] = useState<boolean>(false);
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const userDetails = useAppUserDetailsSelector();
  const performanceList = useAppPerformanceListSelector();
  const [statusModalMesssage, setShowStatusModalMessage] = useState<string>("");
  const [uniqueId, setUniqueId] = useState<string>("");

  const getChallengeList = () => {
    let params = {
      rodeo_event_id: cryptr.decrypt(eventId),
      performance_id: cryptr.decrypt(performanceId),
    };
    eventApi.callGetChallengeList(
      params,
      (message: any, resp: any) => {
        console.log({ resp });
        setChallengeList(resp);
      },
      (message: any) => {
        // toast.error(message);
      }
    );
  };

  const createChallenge = () => {
    let params = {
      rodeo_event_id: cryptr.decrypt(eventId),
      performance_id: cryptr.decrypt(performanceId),
    };

    eventApi.callCreateChallenge(
      params,
      (message: any, resp: any) => {
        console.log({ resp });
        // setChallengeCode(resp?.unique_id);
        let x = [...challengeList];
        x.reverse();
        x.push(resp);
        x.reverse();
        setChallengeList(x);
        toast.success(message);
      },
      (message: any) => {
        // toast.error(message);
      }
    );
  };

  const joinChallenge = (values: any) => {
    // console.log({values})
    let params = {
      unique_id: values?.unique_id,
    };
    eventApi.callJoinChallenge(
      params,
      (message: any, resp: any) => {
        closeJoinChallengeModal();
        let x = [...challengeList];
        x.push(resp);
        setChallengeList(x);

        // console.log({resp})
        toast.success(message);
      },
      (message: any) => {
        toast.error(message);
      }
    );
  };

  const withdrawChallenge = (unique_id: any) => {
    let params = {
      unique_id,
    };

    eventApi.callWithdrawChallenge(
      params,
      (message: any, resp: any) => {
        setChallengeList(challengeList?.filter((x: any) => x.unique_id !== unique_id));
        toast.success(message);
        closeStatusModal();
      },
      (message: any) => {
        // toast.error(message);
      }
    );
  };

  const openJoinChallengeModal = () => {
    setShowJoinChallengeModal(true);
  };

  const closeJoinChallengeModal = () => {
    setShowJoinChallengeModal(false);
  };

  const openStatusModal = (u_id: any) => {
    setShowStatusModalMessage("Are you sure you want to withdraw the challenge?");
    setShowStatusModal(true);
    setUniqueId(u_id);
  };

  const closeStatusModal = () => {
    setShowStatusModalMessage("");
    setShowStatusModal(false);
    setUniqueId("");
  };

  useEffect(() => {
    if (isCopied) {
      toast.success("Challenge code copied successfully");
      setIsCopied(false);
    }
  }, [isCopied]);

  useEffect(() => {
    getChallengeList();
  }, []);

  return (
    <React.Fragment>
      <div className="main-content-panel">
        <div className="team-list-panel pt-3">
          <div className="d-flex justify-content-between align-items-center team-list-title-panel gap-3">
            <div className="team-list-title">
              <h1>{performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.title}</h1>
            </div>
            <div className="team-list-date">
              <p>
                {performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate
                  ? moment(performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate).format(
                      "MMM DD, YYYY"
                    )
                  : ""}
              </p>
            </div>
          </div>
          <div className="team-list-steps-no mb-4 jc-sb">
            <span
              className={"list-steps-no btn " + (activeTab == "create" ? "current" : "")}
              onClick={() => setActiveTab("create")}
            >
              Create Challenge
            </span>
            <span
              className={"list-steps-no btn " + (activeTab == "join" ? "current" : "")}
              onClick={() => setActiveTab("join")}
            >
              Join Challenge
            </span>
          </div>

          {activeTab === "create" && (
            <>
              <div className="d-flex justify-content-center mb-4">
                <button className="btn btn-primary theme-primary-btn" onClick={createChallenge}>
                  Create New Challenge
                </button>
              </div>
              <div>
                {challengeList?.length
                  ? challengeList
                      ?.filter((x: any) => x.home_user_id == userDetails?.id)
                      ?.map((item: any, index: any) => (
                        <div key={index} className="challenge-list-item">
                          <div className="unique-code">{item?.unique_id}</div>
                          {item?.away_user_details?.display_name ? (
                            <>
                              <div style={{ color: "#3bb5a4" }}>Joined by {item?.away_user_details?.display_name}</div>
                              <button className="small-btn del" onClick={() => openStatusModal(item?.unique_id)}>
                                <i className="fa fa-trash" />
                              </button>
                            </>
                          ) : (
                            <>
                              <CopyToClipboard text={item?.unique_id} onCopy={() => setIsCopied(true)}>
                                <button className="small-btn">
                                  <i className="fa fa-copy" />
                                </button>
                              </CopyToClipboard>
                              <button className="small-btn del" onClick={() => openStatusModal(item?.unique_id)}>
                                <i className="fa fa-trash" />
                              </button>
                            </>
                          )}
                        </div>
                      ))
                  : null}
              </div>
            </>
          )}

          {activeTab === "join" && (
            <>
              <div className="d-flex justify-content-center mb-4">
                <button className="btn btn-primary theme-primary-btn" onClick={openJoinChallengeModal}>
                  Join Challenge
                </button>
              </div>
              <div>
                {challengeList?.length
                  ? challengeList
                      ?.filter((x: any) => x.away_user_id == userDetails?.id)
                      ?.map((item: any, index: any) => (
                        <div key={index} className="challenge-list-item">
                          <div className="unique-code">{item?.unique_id}</div>
                          {item?.home_user_details?.display_name ? (
                            <>
                              <div style={{ color: "#3bb5a4" }}>Created by {item?.home_user_details?.display_name}</div>
                              {/* <button className="small-btn del" onClick={() => withdrawChallenge(item?.unique_id)}> */}
                              <button className="small-btn del" onClick={() => openStatusModal(item?.unique_id)}>
                                <i className="fa fa-trash" />
                              </button>
                            </>
                          ) : null}
                        </div>
                      ))
                  : null}
              </div>
            </>
          )}
        </div>
      </div>
      {showJoinChallengeModal && (
        <JoinChallengeModal
          onClose={() => setShowJoinChallengeModal(false)}
          shouldShow={showJoinChallengeModal}
          joinChallenge={joinChallenge}
        />
      )}
      {showStatusModal && statusModalMesssage && uniqueId && (
        <StatusModal
          shouldShow={showStatusModal}
          onSuccess={withdrawChallenge}
          onClose={closeStatusModal}
          message={statusModalMesssage}
          type={3}
          unique_id={uniqueId}
        />
      )}
      <Sponsor />
    </React.Fragment>
  );
};

export default CreateChallengeComponent;
